import { CloseIcon } from '@calizahq/react-components-v2'
import styled from '@emotion/styled'
import clsx from 'clsx'
import React, { useEffect, useRef, useState } from 'react'

import { APP_TYPE } from '@/types/User'

import Burger from './HeaderBurger'

type Props = {
  activeApp: APP_TYPE
  minimize: boolean
  toggleSideBar: () => void
}

export const Header: React.FC<Props> = ({ minimize, activeApp, toggleSideBar }) => {
  const headerRef = useRef<HTMLElement>(null)

  const [showHeader, setShowHeader] = useState(true)
  const [lastScroll, setLastScroll] = useState(0)
  const acceptableVariance = 32

  useEffect(() => {
    const onScroll = () => {
      const currentScroll = window.pageYOffset
      if (currentScroll <= acceptableVariance) {
        setShowHeader(true)
        return
      }

      if (currentScroll > lastScroll) {
        setShowHeader(false)
      }
      if (currentScroll + acceptableVariance < lastScroll) {
        setShowHeader(true)
      }
      setLastScroll(currentScroll)
    }
    // clean up code
    window.removeEventListener('scroll', onScroll)
    window.addEventListener('scroll', onScroll)
    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  }, [lastScroll])

  return (
    <StickyHeaderStyled activeApp={activeApp} id="header" ref={headerRef} show={showHeader || !minimize}>
      <div className={`relative flex h-16 w-full items-center px-4 md:h-18`}>
        {!minimize ? (
          <button className="mr-8 h-5 w-5" onClick={toggleSideBar}>
            <CloseIcon
              className={clsx(activeApp === APP_TYPE.SALES ? 'icon-semantic-black' : 'icon-on-media')}
              height={24}
              width={24}
            />
          </button>
        ) : (
          <Burger activeApp={activeApp} onClick={toggleSideBar} open={false} />
        )}
        <a className="mt-0.5" href={'/'}>
          <p
            className={clsx('text-xl', activeApp === APP_TYPE.SALES ? 'text-action-input' : 'text-white')}
            style={{ fontWeight: 700 }}
          >
            Mission Control
          </p>
        </a>
      </div>
    </StickyHeaderStyled>
  )
}

const StickyHeaderStyled = styled.nav<{ activeApp: APP_TYPE; show: boolean }>`
  position: fixed;
  left: 0;
  z-index: 40;
  display: flex;
  width: 100%;
  transition-property: color, background-color, border-color;
  transition-duration: 1000ms;
  @media (min-width: 1024px) {
    display: none;
  }
  ${({ activeApp }) => (activeApp === APP_TYPE.SALES ? 'background-color: white;' : 'background-color: #000000;')}
  transition: all cubic-bezier(0.075, 0.82, 0.165, 1);

  ${({ show }) => {
    if (show) {
      return `top:0;`
    } else {
      return `top:-64px;`
    }
  }}
`
